import { DragDropModule } from "@angular/cdk/drag-drop";
import { CdkMenuModule } from "@angular/cdk/menu";
import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { NgbCollapseModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
import { TcmCommonSharedModule } from "../tcm-common/tcm-common.shared.module";
import { TCMCoreModule } from "../tcm-core.module/tcm-core.module";
import { TCMFormModule } from "../tcm-form/tcm-form.module";
import { BrandInfoWidgetComponent } from "./brand-widget/brand-info-widget.component";
import { UpdateBrandLogoComponent } from "./brand-widget/update-logo/update-brand-logo.component";
import { ClaimInfoWidgetComponent } from "./claim-info-widget/claim-info-widget.component";
import { ClinicInfoWidgetComponent } from "./clinic-widget/clinic-info-widget.component";
import { UpdateClinicLogoComponent } from "./clinic-widget/update-logo/update-clinic-logo.component";
import { CompanyInfoWidgetComponent } from "./company-widget/company-info-widget.component";
import { UpdateCompanyLogoComponent } from "./company-widget/update-logo/update-company-logo.component";
import { FittingReportEditorComponent } from "./fitting-report-2-editor/fitting-report-2-editor.component";
import { LastAttachmentsWidgetComponent } from "./last-attachments-widget/last-attachments-widget.component";
import { NoahAudiogramViewComponent } from "./noah-audiogram-view/noah-audiogram-view.component";
import { NoahGraphComponent } from "./noah-graph/noah-graph.component";
import { NoahValuesComponent } from "./noah-values/noah-values.component";
import { ExplorerComponent } from "./patient-widget/file-explorer/explorer/explorer.component";
import { FileExplorerApiService } from "./patient-widget/file-explorer/file-explorer.api.service";
import { FileExplorerComponent } from "./patient-widget/file-explorer/file-explorer.component";
import { FileExplorerService } from "./patient-widget/file-explorer/file-explorer.service";
import { FileManagerDirTreeComponent } from "./patient-widget/file-explorer/side/side.component";
import { TreeNodeComponent, TreeFolderFilterPipe } from "./patient-widget/file-explorer/side/tree.component";
import { FileNameAlreadyExistsValidator } from "./patient-widget/file-explorer/validators/file-name-already-exists-validator";
import { FileNameContainSpecificSymbolsValidator } from "./patient-widget/file-explorer/validators/file-name-contain-specific-symbols-validator";
import { PatientEquipmentWidgetLinkedSearchComponent } from "./patient-widget/latest-equipment/patient-equipment-widget-search.component";
import { NoahShortInfoComponent } from "./patient-widget/noah-short-info/noah-short-info.component";
import { PatientAlertShowUpComponent } from "./patient-widget/patient-alert-show-up/patient-alert-show-up.component";
import { PatientInfoWidgetComponent } from "./patient-widget/patient-info-widget.component";
import { PatientJournalComponent } from "./patient-widget/patient-journal/patient-journal.component";
import { SendEmailComponent } from "./patient-widget/send-email/send-email.component";
import { SendSmsComponent } from "./patient-widget/send-sms/send-sms.component";
import { TimeSpentPipe } from "./patient-widget/time-spent.pipe";
import { UpdatePhotoComponent } from "./patient-widget/update-photo/update-photo.component";
import { provideNgxWebstorage, withLocalStorage, withNgxWebstorageConfig } from "ngx-webstorage";

@NgModule({
    declarations: [
        LastAttachmentsWidgetComponent,
        PatientInfoWidgetComponent,
        UpdatePhotoComponent,
        ClinicInfoWidgetComponent,
        UpdateClinicLogoComponent,
        FittingReportEditorComponent,
        TimeSpentPipe,
        ClaimInfoWidgetComponent,
        FileExplorerComponent,
        TreeNodeComponent,
        FileManagerDirTreeComponent,
        TreeFolderFilterPipe,
        ExplorerComponent,
        FileNameAlreadyExistsValidator,
        FileNameContainSpecificSymbolsValidator,
        PatientJournalComponent,
        PatientAlertShowUpComponent,
        NoahShortInfoComponent,
        NoahAudiogramViewComponent,
        NoahGraphComponent,
        NoahValuesComponent,
        CompanyInfoWidgetComponent,
        UpdateCompanyLogoComponent,
        BrandInfoWidgetComponent,
        UpdateBrandLogoComponent,
        SendSmsComponent,
    SendEmailComponent,
    PatientEquipmentWidgetLinkedSearchComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        TranslateModule,
        NgbCollapseModule,
        TCMCoreModule,
        TCMFormModule,
        TcmCommonSharedModule,
        DragDropModule,
        CdkMenuModule
    ],
    providers: [
        FileExplorerService,
        FileExplorerApiService,
        provideNgxWebstorage(
                  withNgxWebstorageConfig({ separator: ':', caseSensitive: true }),
                  withLocalStorage(),
                ),
    ],
    exports: [
        LastAttachmentsWidgetComponent,
        PatientInfoWidgetComponent,
        UpdatePhotoComponent,
        ClinicInfoWidgetComponent,
        UpdateClinicLogoComponent,
        FittingReportEditorComponent,
        ClaimInfoWidgetComponent,
        FileExplorerComponent,
        PatientJournalComponent,
        NoahAudiogramViewComponent,
        PatientJournalComponent,
        NoahGraphComponent,
        CompanyInfoWidgetComponent,
        UpdateCompanyLogoComponent,
        BrandInfoWidgetComponent,
        UpdateBrandLogoComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class WidgetsModule { }
